import { lazy } from "react";
import { infoPortalRoutes } from "./infoPortalRoutes";

const DashboardNav = lazy(() =>
    import("../shared/Components/Navigation/DashboardNav/DashboardNav")
);
const DashboardView = lazy(() => import("../dashboard/pages/DashboardView"));
const ProfileView = lazy(() => import("../users/pages/profile/ProfileView"));
const EmailVerifyView = lazy(() => import("../users/pages/auth/EmailVerifyView"));
const MunaqasyahView = lazy(() => import("../munaqasyah/pages/MunaqasyahView"));
const QuestionBankView = lazy(() =>
    import("../munaqasyah/pages/QuestionBankView")
);
const QuestionBankByClassView = lazy(() =>
    import("../munaqasyah/pages/QuestionBankByClassView")
);
const NewQuestionView = lazy(() =>
    import("../munaqasyah/pages/NewQuestionView")
);
const QuestionDetailView = lazy(() =>
    import("../munaqasyah/pages/QuestionDetailView")
);
const UpdateQuestionView = lazy(() =>
    import("../munaqasyah/pages/UpdateQuestionView")
);
const QuestionPackageView = lazy(() =>
    import("../munaqasyah/pages/QuestionPackageView")
);
const CategoryPackageView = lazy(() =>
    import("../munaqasyah/pages/CategoryPackageView")
);
const HelpCenterView = lazy(() => import("../help-center/pages/HelpCenterView"));

export const curriculumRoutes = [
    { path: "/verify-email/:token", element: <EmailVerifyView /> },
    { path: "/profile/:userId", element: <ProfileView /> },
    { path: "/dashboard", element: <DashboardView /> },
    { path: "/help-center", element: <HelpCenterView /> },
    { path: "/munaqasyah", element: <MunaqasyahView /> },
    {
        path: "/munaqasyah/question-bank",
        element: <QuestionBankByClassView />,
    },
    {
        path: "/munaqasyah/question-bank/:classGrade",
        element: <QuestionBankView />,
    },
    {
        path: "/munaqasyah/question-bank/:classGrade/new",
        element: <NewQuestionView />,
    },
    {
        path: "/munaqasyah/question-bank/:classGrade/:questionId",
        element: <QuestionDetailView />,
    },
    {
        path: "/munaqasyah/question-bank/:classGrade/:questionId/update",
        element: <UpdateQuestionView />,
    },
    { path: "/munaqasyah/question-package", element: <QuestionPackageView /> },
    {
        path: "/munaqasyah/question-package/class",
        element: <CategoryPackageView />,
    },
    // Info Portal routes (accessible to all authenticated users)
    ...infoPortalRoutes,
];

export const CurriculumRouteWrapper = ({ children }) => (
    <DashboardNav>{children}</DashboardNav>
);
